import { connect } from 'react-redux';
import styled from 'styled-components';

import AlertsTable from '../organisms/AlertsTable/AlertsTable';
import { ListSkeleton } from '../molecules/ListSkeleton/ListSkeleton';


const AlertsPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AlertsPage = (props) => {
  const {
    notifications: { notifications },
    chargePoints: {chargePointList}
  } = props;

  return notifications?.notificationList?.length && chargePointList?.length ? (
    <AlertsPageWrapper>
      <AlertsTable notifications={notifications?.notificationList} />
    </AlertsPageWrapper>
  ) : (
    <AlertsPageWrapper>
      <ListSkeleton style={{ paddingTop: 20, paddingLeft: 20, paddingRight: 20 }} />
    </AlertsPageWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    notifications: state.notifications,
    chargePoints: state.chargePoints.chargePoints
  };
};

export default connect(mapStateToProps)(AlertsPage);
